import { apiCallWithAuthWithReturn, handleResponseErrorData } from "../utils/commonUtils";
import { serviceGetClinicBasicDetails, serviceGetClinicContactDetails } from "./profileApi";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const fetchServicesByClinicIdAndName = async (clinicId, serviceName) => {
  try {
    const url = `${API_BASE_URL}/invoices/services?clinicId=${clinicId}&serviceName=${serviceName}`;
    const response = await apiCallWithAuthWithReturn(url, 'GET', null, {}, null);
    if(response?.status) {
      return response.data;
    } else {
      throw response;
    }
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const saveBillingData = async (invoiceData, pdfBlob,whatsappSelected=false) => {
  try {
    const formData = new FormData();
    formData.append('invoiceData', JSON.stringify(invoiceData));
    formData.append('pdf', pdfBlob, 'invoice.pdf');
    formData.append('whatsapp', whatsappSelected);
    
    const url = `${API_BASE_URL}/invoices/saveBillingData`;
    return await apiCallWithAuthWithReturn(url, 'POST', formData, {}, null, { "removeContentType" : true });
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const updateInvoiceData = async (invoiceData, pdfBlob,whatsappSelected=false) => {
  try {
    const formData = new FormData();
    formData.append('invoiceData', JSON.stringify(invoiceData));
    formData.append('pdf', pdfBlob, 'invoice.pdf');
    formData.append('whatsapp', whatsappSelected);
    
    const url = `${API_BASE_URL}/invoices/updateInvoiceData`;
    return await apiCallWithAuthWithReturn(url, 'POST', formData, {}, null, { "removeContentType" : true });
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const fetchClinicBasicDetails = async (clinicId) => {
  try {
    const responseData = await serviceGetClinicBasicDetails({ clinicId });
    if(responseData?.status) {
      return responseData?.data?.clinicName;
    }
    return null;
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const fetchClinicContactDetails = async (userId) => {
  try {
    const responseData = await serviceGetClinicContactDetails({ userId });
    if(responseData?.status) {
      return responseData?.data?.contactInfo;
    }
    return null;
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};

export const serviceSendInvoiceDataToWhatsapp = async(InvoiceData) => {
  const data = JSON.stringify(InvoiceData);
  try {
      const url= `${process.env.REACT_APP_API_URL}/invoices/sendInvoicetoWhatsapp`;
      return await apiCallWithAuthWithReturn(url,'POST', data, {"Content-Type": "application/json",}, null);
  } catch (error) {
      return handleResponseErrorData(error, null);
  }
}
export const saveInvalidatePaymentData = async (params) => {
  try {
    const data=JSON.stringify(params);
    const url = `${API_BASE_URL}/invoices/invalidatepayment`;
    return await apiCallWithAuthWithReturn(url, 'POST', data, {"Content-Type": "application/json"}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};
export const saveInvalidateBillData = async (params) => {
  try {
    const data=JSON.stringify(params);
    const url = `${API_BASE_URL}/invoices/invalidatebill`;
    return await apiCallWithAuthWithReturn(url, 'POST', data, {"Content-Type": "application/json"}, null);
  } catch (error) {
    return handleResponseErrorData(error, null);
  }
};